<template>
	<div>
		<div :id="carouselId" class="owl-carousel standard-rem" :class="carouselClass">
			<template v-for="( item, itemIdx ) in carouselData">
				<div class="item" :key="`${carouselId}-${itemIdx}`"> <!--v-if="item.VISIBLE_ON_CWP"-->
					<div :class="[ 'panel', 'panel-' + colorVariant ]">
						<div class="panel-heading">
							<span v-if="item.END_DATE" :class="'badge due-' + getDueStatus( item.END_DATE )">
								<strong> {{$t('MAIN_CONTENT.classPage.AssignmentCarousel.classPage_due')}}</strong> {{ formatDate( item.END_DATE ) }} 
							</span>
							<span v-else class="badge badge-secondary due-none">{{$t('MAIN_CONTENT.classPage.AssignmentCarousel.classPage_noDueDate')}}</span>
						</div>
						<div class="panel-body text-center" :class="'panel-body-' + carouselId">
							<div class="col-xs-12 no-overflow"
									 v-tooltip.top-center="{ content: item.NAME, trigger: 'hover click' }">
									<p>
									<strong style="white-space: nowrap;">
										{{ item.NAME }}
									</strong>
									<br />
									<span v-if="!!item.COURSE_TITLE">{{item.COURSE_TITLE}}</span>
									<span v-if="!!item.COURSE_SECTION_TITLE">{{item.COURSE_SECTION_TITLE}}</span>
									<br/>
									<span v-if="item.POINTS">
										{{ $t('MAIN_CONTENT.classPage.AssignmentCarousel.classPage_pointsWithPoints', { points: item.POINTS } ) }}
									</span>
									<span v-else>&nbsp;</span>
								</p>
							</div>
							<span v-if="item.TEST_RID && item.END_DATE" class="text-sm">
								{{ $t( 'MAIN_CONTENT.classPage.AssignmentCarousel.classPage_testClosesAt', { time: getTime( item.END_DATE ) } ) }}
							</span> <br/>
							<button class="btn btn-primary standard-rem"
											v-if="item.TEST_RID && item.TEST_ENDED_FLG !== 'Y'"
											@click="openTest(item)">
								<span v-if="role === 'student'">{{ $t('MAIN_CONTENT.AssignmentsCarousel.takeTestText') }}</span>
								<span v-else>Info</span>
								<br />
							</button>
							<button class="btn btn-primary standard-rem"
											v-else-if="item.GRADING_COMPLETE_FLG === 'Y'"
											@click="reviewTest(item)">
								<span>{{ $t('MAIN_CONTENT.AssignmentsCarousel.reviewTestText') }}</span><br/>
							</button>
							<button class="btn btn-primary standard-rem"
											@click="openDropboxAssignment(item)"
											v-else-if="item.DROPBOX_ASSIGNMENT_ID">
								<span>{{ $t('MAIN_CONTENT.classPage.AssignmentCarousel.classPage_uploadSubmission') }}</span><br/>
							</button>
						</div>
					</div>
				</div>
			</template>
		</div>
		<!-- Modal -->
		<modal :modal-title="$t('commonText.unauthorizedAccess')"
					 :show="showModal"
					 dialog-size="sm"
					 name="AssignmentOwlCarousel"
					 id="carouselModal"
					 @close="closeModal()">
			<template slot-scope="modalProps">
				<p id="OwlModalContent" tabindex="0">
					{{ $t('commonText.parentAccountTestRestrictionMessage') }}
				</p>
			</template>
			<template slot="footer">
				<button type="button" class="btn btn-transparent pull-right" @click="closeModal()">
					{{ $t('MAIN_CONTENT.commonContent.closeButton') }}
				</button>
			</template>
		</modal>
	</div>
</template>

<script>
	import Owl from 'owl.carousel';
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';

	import LogClassPageActivityResource from '../../api/ClassPageLog';

	import Modal from 'COMMONS/shared/Modal/Modal.vue';

	export default {
		name: 'AssignmentOwlCarousel',
		props: {
			carouselId: { 				// unique carousel Id
				type: String,
				required: true
			},
			carouselClass: {			// carousel class
				type: String
			},
			itemsOnStage: {				// items on screen
				type: Number,
				default: 3
			},
			loop: {
				type: Boolean,
				default: false
			},
			margin: {					// right marging of each item
				type: Number,
				default: 4
			},
			showNav: {					// show nav's prev and next buttons
				type: Boolean,
				default: false
			},
			autoPlay: {
				type: Boolean,
				default: false
			},
			navContainer: {
				type: String,
				default: ""
			},
			carouselData: {
				type: Array
			},
			showCourse: {
				type: Boolean,
				default: true
			},
			colorVariant: {
				type: String,
				default: "neutral"
			}
		},
		data() {
			return {
				isLoading: false,
				showModal: false
			}
		},
		computed: {
			...mapGetters(['selectedStudent', 'role'])
		},
		components: {
			Modal
		},
		directives: {
			'tooltip': VTooltip,
		},
		methods : {
			initOwlCarousel() {
				$( '#' + this.carouselId ).owlCarousel(
					{
						loop: this.loop,
						items: this.itemsOnStage,
						margin: this.margin,
						navText: [ "<i class='fas fa-chevron-left'></i> SOONER", "LATER <i class='fas fa-chevron-right'></i>" ],
						responsive: {
							0: {
								items:1
							},
							600: {
								items:this.itemsOnStage - 1
							},
							1000: {
								items:this.itemsOnStage
							}
						},
						responsiveRefreshRate: 200,
						autoplay: false,
						autoplayHoverPause: this.autoPlay,
						nav: this.showNav,
						navContainer: this.navContainer,
						stagePadding: 50,
						dots: false
					}
				);

				this.matchHeightOfClass( 'panel-body-' + this.carouselId );
			},
			formatDate( date ) {
				return moment( date ).format( 'MM/DD/YYYY' );
			},
			getDueStatus( date ){
				if( moment( this.formatDate(date) ).isSameOrBefore( moment( moment().format('MM/DD/YYYY') ).add( 1, 'day' ) ) ){
					return 'danger';
				} else if ( moment( this.formatDate(date) ).isBetween( moment(moment().format('MM/DD/YYYY')).add( 1, 'day' ), moment(moment().format('MM/DD/YYYY')).add( 7, 'day' ), '', '(]') ){
					return 'warning';
				} else {
					return 'info';
				}
			},
			getTime( date ) {
				return moment( date ).format( 'h:mm:ss A' );
			},
			/**
				* Matches the height of elements with the same class name
				* @param {String} className - name of class  to targtet
			*/
			matchHeightOfClass( className ) {
				let elements = [ ...document.getElementsByClassName( className ) ];
				let height = elements.reduce(
					( tallest, el ) => tallest > el.getBoundingClientRect().height ? tallest : el.getBoundingClientRect().height, 0
				);

				elements.forEach( el => el.style.height = Math.ceil( height ) + "px" );
			},
			openDropboxAssignment(assignment) {
				this.logClassPageActivity(assignment);

				const viewsMap = {
					"C": "ClassPageAssignmentBinSubmission",
					"G": "ClassPageGroupAssignmentBinSubmission",
					"S": "ClassPageStudentAssignmentBinSubmission",
					"P": "ClassPageSectionAssignmentBinSubmission"
				};
				const view = viewsMap[assignment.DROPBOX.FOLDER_TYPE ? assignment.DROPBOX.FOLDER_TYPE : "C"];

				let params = {
					courseSectionGUID: !!assignment.COURSE_SECTION_GUID ? assignment.COURSE_SECTION_GUID : this.$route.params.courseSectionGUID,
					studentRid: this.selectedStudent.STUDENT_RID,
					assignmentBinId: assignment.DROPBOX.LINE_NO,
					assignmentId: assignment.DROPBOX_ASSIGNMENT_ID,
					folderId: assignment.DROPBOX.FOLDER_ID,
				};

				if( assignment.DROPBOX.FOLDER_TYPE === 'G' ) {
					params.groupId = assignment.DROPBOX.FOLDER_ID;
				}

				if( assignment.DROPBOX.FOLDER_TYPE === 'S') {
					params.studentRid = this.selectedStudent.STUDENT_RID;
				}

				this.$router.push({
					name: view,
					params: params,
				});
			},
			openTest(test) {
				let routeData = this.$router.resolve({
					name: "testTaker", 
					params: {
						testRid: test.TEST_RID
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
						school_id: test.SCHOOL_ID,
						course_id: test.COURSE_ID,
						section_id: test.SECTION_ID,
						teacher_rid: test.TEACHER_RID
					}
				});

				if(this.role === 'student') {
					window.open(routeData.href, '_blank');
				} else {
					this.showModal = true;
					document.getElementById('OwlModalContent').focus();
				}
			},
			reviewTest(test) {
				let routeData = this.$router.resolve({
					name: "testReviewer",
					params: {
						testRid: test.TEST_RID
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
						school_id: test.SCHOOL_ID,
						course_id: test.COURSE_ID,
						section_id: test.SECTION_ID,
						teacher_rid: test.TEACHER_RID
					}
				});
				window.open(routeData.href, '_blank');
			},
			logClassPageActivity(item) {
				const logClassPageActivity = new LogClassPageActivityResource({
					routeParams: {
						courseSectionGuid: !!item.COURSE_SECTION_GUID ? item.COURSE_SECTION_GUID : this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
					data: {
						folder_type: item.DROPBOX.FOLDER_TYPE,
						line_no: item.DROPBOX.LINE_NO
					},
				});

				logClassPageActivity.post();
			},
			closeModal() {
				this.showModal = false;
			}
		},
		mounted() {
			this.$nextTick(function() {
				this.initOwlCarousel();
			});
		}
	}
</script>
